import { render, staticRenderFns } from "./trainAccountStatus.vue?vue&type=template&id=a3540794&scoped=true&"
import script from "./trainAccountStatus.vue?vue&type=script&lang=ts&"
export * from "./trainAccountStatus.vue?vue&type=script&lang=ts&"
import style0 from "./trainAccountStatus.vue?vue&type=style&index=0&id=a3540794&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3540794",
  null
  
)

export default component.exports